import React, { useEffect, useState } from 'react';
import "./CadastrarEstabelecmentoSaude.css";
import Navbar from '../../../components/layout/Navbar/Navbar';
import Sidebar from '../../../components/layout/Sidebar/Sidebar';
import EsHeader from '../../../components/Estabelecimento-Saude/EstabelecimentoSaudeHeader';
import EsForm from '../../../components/Estabelecimento-Saude/EstabelecimentoSaude';
import { getCargoIdSidebar } from '../../../constants/sidebarConfig';
import apiService from '../../../services/api';

const EsData = () => {
  const [sidebarItems, setSidebarItems] = useState([]);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userData = await apiService.getCurrentUser();
        const filteredItems = getCargoIdSidebar(userData.cargoId);
        setSidebarItems(filteredItems);
      } catch (err) {
        console.error('Erro ao buscar usuário:', err);
      }
    };
  
    fetchUser();
  }, []);

  return (
    <div className="CadastrarVagasEstagio-Page">
      <div className="navbar">
        <Navbar onLogout={apiService.logout}/>
      </div>
      <div className="container">
        <div className="sidebar">
          <Sidebar items={sidebarItems} />
        </div>
        <div className="main-content">
          <EsHeader />
          <EsForm />
        </div>
      </div>
    </div>
  );
};

export default EsData;